import { render, staticRenderFns } from "./SmtpSettings.vue?vue&type=template&id=f631fff8&scoped=true&"
import script from "./SmtpSettings.vue?vue&type=script&lang=js&"
export * from "./SmtpSettings.vue?vue&type=script&lang=js&"
import style0 from "./SmtpSettings.vue?vue&type=style&index=0&id=f631fff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f631fff8",
  null
  
)

export default component.exports